import React from "react";

const NoImages = () => (
  <div>
    <h2>No Images Found</h2>
    <p>Please try a different search term</p>
  </div>
);

export default NoImages;